import { render, staticRenderFns } from "./ClinicalArchive.vue?vue&type=template&id=a452b982&scoped=true&"
import script from "./ClinicalArchive.vue?vue&type=script&lang=ts&"
export * from "./ClinicalArchive.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicalArchive.vue?vue&type=style&index=0&id=a452b982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a452b982",
  null
  
)

export default component.exports